import CacheCleaner from "./CacheCleaner"
import Common from '@/assets/js/common.js'

export default class ArticleCleaner extends CacheCleaner {

	async onMutation(article_ids) {
		Common.storageDelete('all_actes_groupes')
	}
}